export default "__VITE_ASSET__DlMKP86m__"